import { UpsellingButton as F0UpsellButton } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

interface UpsellButtonProps {
  label?: string
  size: string
  onClick: () => Promise<void>
}

const UpsellButton = ({ label, size, onClick }: UpsellButtonProps) => {
  return (
    <F0UpsellButton
      label={label ?? i18n.t('upselling_kit.button.request_information')}
      size={size}
      onRequest={onClick}
      errorMessage={{
        title: i18n.t('upselling_kit.upselling_button.error_message.title'),
        description: i18n.t('upselling_kit.upselling_button.error_message.description'),
      }}
      successMessage={{
        title: i18n.t('upselling_kit.upselling_button.success_message.title_2'),
        description: i18n.t('upselling_kit.upselling_button.success_message.description'),
      }}
      loadingState={{
        label: i18n.t('upselling_kit.upselling_button.loading_state.label'),
      }}
      nextSteps={{
        title: '',
        items: [],
      }}
      closeLabel={i18n.t('upselling_kit.upselling_button.close_label')}
    />
  )
}

export default UpsellButton
